// extracted by mini-css-extract-plugin
export var banner = "_3h-0";
export var icon = "_3h-1";
export var message = "_3h-2";